import { CommonFeatures } from '../types/CommonFeatures'
import { CommonFeature } from '../types/CommonFeature'
import {
  FeatureGroupModel,
  TextBlockModel,
  FeatureModel,
  mapMediaLinks,
  mapFirstReferenceData,
  mapManyReferenceData,
} from '@vp/digital-common-data-model-lib-ubik'

export function commonFeaturesToFeatureGroup(commonFeatures: CommonFeatures): FeatureGroupModel {
  const firstMediaLink = commonFeatures.mediaLink?.[0]

  return {
    key: commonFeatures.key,
    title: commonFeatures.title ?? '',
    description: commonFeatures.description ?? undefined,
    features: commonFeatures.features?.map((commonFeature) => mapCommonFeatureToFeature(commonFeature)) ?? [],
    media: commonFeatures.media?.map((commonFeature) => mapCommonFeatureToFeature(commonFeature)) ?? undefined,
    mediaUrl: firstMediaLink?.url,
    mediaType: firstMediaLink?.resourceType,
  }
}

function mapCommonFeatureToFeature(commonFeature: CommonFeature): FeatureModel {
  const feature = mapCommonFeatureToTextBlock(commonFeature)
  return feature as FeatureModel
}

function mapCommonFeatureToTextBlock(commonFeature: CommonFeature, mapfirstReferenceItem: boolean = true): TextBlockModel {
  const textBlock: TextBlockModel = {
    title: commonFeature?.name ?? '',
  }

  textBlock.key = commonFeature?.key

  textBlock.description = commonFeature?.description ?? ''

  textBlock.altText = commonFeature?.altText ?? ''

  textBlock.hoverText = commonFeature?.hoverText ?? ''

  textBlock.valueText = commonFeature?.valueText ?? ''

  textBlock.mediaName = commonFeature?.mediaName ?? ''

  if (commonFeature?.mediaLink) {
    textBlock.icons = mapMediaLinks(commonFeature.mediaLink)
  }

  if (commonFeature?.mobileMediaLink) {
    textBlock.iconsMobile = mapMediaLinks(commonFeature.mobileMediaLink)
  }

  if (commonFeature?.mediaLink?.[0]) {
    textBlock.mediaUrl = commonFeature.mediaLink[0].secure_url
    textBlock.mediaType = commonFeature.mediaLink[0].resourceType
  }

  if (commonFeature?.referenceData && commonFeature?.referenceData.length > 0) {
    if (mapfirstReferenceItem) {
      textBlock.reference = mapFirstReferenceData(commonFeature.referenceData)
    } else {
      textBlock.reference = mapManyReferenceData(commonFeature.referenceData)
    }
  }
  return textBlock
}
